// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".07336e1a121a4888e6ba1cffdd2f448ca37c86ba.chunk.js";
};